import type { PlanType } from '@simplywallst/services';
import { useCloudflareImage, getStaticUrl } from '@/hooks/useCloudflareImage';

type ValidPlanType = Exclude<PlanType, ''>;

export const usePlanIllustration = () => {
  const freeBearSrc = useCloudflareImage({
    src: getStaticUrl('free-bear.png'),
    width: 208,
  });
  const premiumBearSrc = useCloudflareImage({
    src: getStaticUrl('premium-bear.png'),
    width: 208,
  });
  const unlimitedBearSrc = useCloudflareImage({
    src: getStaticUrl('unlimited-bear.png'),
    width: 208,
  });

  const tierBearMapping: Record<ValidPlanType, string> = {
    free: freeBearSrc,
    premium: premiumBearSrc,
    unlimited: unlimitedBearSrc,
    advisor: unlimitedBearSrc,
  };

  return tierBearMapping;
};
